import {
  ChangeDetectionStrategy,
  Component,
  Input,
  HostBinding,
  EventEmitter,
  Output,
} from "@angular/core";

@Component({
  selector: "live-switcher",
  templateUrl: "./liveSwitcher.component.html",
  styleUrls: ["./liveSwitcher.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiveSwitcherComponent {
  @HostBinding("class.switchOptionsIsActive") switchOptionsIsActive: boolean =
    false;

  @Output()
  onOnewaySwitch = new EventEmitter();

  @Output()
  onVideoSwitch = new EventEmitter();

  /**
   * Starting Switcher Component
   * @retrun void
   */
  ngOnInit() {
    // console.log("LOVE LOVE LOVE");
  }

  /**
   * Pushing preview as live stream and remove preview from queue
   * @param event
   * @retrun void
   */
  oneWaySwitch(event) {
    this.onOnewaySwitch.emit(true);
  }

  /**
   * Switching between preview and live - Pushing preview to live and live to preview
   * @param event
   * @retrun void
   */
  videoSwitch(event) {
    this.onVideoSwitch.emit(true);
    // console.log("Switch between live and preview");
  }

  /**
   * Change open status for swticher
   * @param event
   */
  openSwitcherOption(event) {
    this.switchOptionsIsActive = !this.switchOptionsIsActive;
  }
}
